import { render } from "./CalculatorIpsPage.vue?vue&type=template&id=4936dba4"
import script from "./CalculatorIpsPage.vue?vue&type=script&lang=js"
export * from "./CalculatorIpsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__